import {
  Observable,
  Subject,
  BehaviorSubject,
  of,
  Subscription,
  timer,
} from "rxjs";
import { NgSelectComponent } from "@ng-select/ng-select";
import { Router } from "@angular/router";
import {
  OfflineBookingAllList,
  OfflineBookingList,
  OfflineBookingListOnlineDetailsOrOffline,
} from "../Models/OfflineBookingProperties";
import { OfflineRequestTypes } from "../Models/ActiveClasses";

import { OfflineRequestService } from "../Services/offline-request.service";
import { NgForm, FormsModule } from "@angular/forms";
import {
  Component,
  ElementRef,
  ViewChild,
  OnInit,
  AfterViewInit,
} from "@angular/core";
import { DatePipe, KeyValuePipe } from "@angular/common";
import * as $ from "jquery";
import {
  OfflineToOnlineProperties,
  TicketPnrRights,
} from "../Models/TicketIssuanceProperties";
import { TicketIssuanceService } from "../Services/ticketIssuance.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { map } from "rxjs/operators";
import { DxDataGridComponent, DxLoadPanelModule, DxDataGridModule } from "devextreme-angular";
import { OfflineNewVersionService } from "../Services/offline-newVersion.service";
import { OfflineNewVersionProperties, OfflineRequestTypeEnum } from "../offline-new/offlineNewProperties";
import { NavMenuComponent } from "../nav-menu/nav-menu.component";
import { Bind } from "primeng/bind";
import { Dialog } from "primeng/dialog";
import { Tabs, TabList, Tab, TabPanels, TabPanel } from "primeng/tabs";
import { Ripple } from "primeng/ripple";
import { DxoFilterRowModule, DxiColumnModule, DxiButtonModule, DxoSearchPanelModule, DxoPagingModule, DxoPagerModule } from "devextreme-angular/ui/nested";

@Component({
    selector: "app-manager-offline-request-list",
    templateUrl: "./manager-offline-request-list.component.html",
    styleUrls: ["./manager-offline-request-list.component.css"],
    imports: [NavMenuComponent, DxLoadPanelModule, Bind, Dialog, Tabs, TabList, Ripple, Tab, TabPanels, TabPanel, FormsModule, DxDataGridModule, DxoFilterRowModule, DxiColumnModule, DxiButtonModule, DxoSearchPanelModule, DxoPagingModule, DxoPagerModule, DatePipe, KeyValuePipe]
})

/** ManagerOfflineRequestList component*/
export class ManagerOfflineRequestListComponent implements OnInit {
  /** ManagerOfflineRequestList ctor */
  requestTypeList$: Observable<OfflineRequestTypes[]>;
  offlineOrOnlineRequestList = new OfflineBookingListOnlineDetailsOrOffline();
  requestList: OfflineBookingAllList[];
  //filteredRequests: OfflineBookingAllList[];
  requestListForConverting: OfflineBookingAllList[];
  userId: number = 0;
  tktPnrRight = new TicketPnrRights();
  agencyId: string = "";
  collapsed = false;
  requestTypeId: number = 0;
  isLoadPanelVisible: boolean = false;
  timerSubscription: Subscription;
  constructor(
    private NewSuccess: NgbModal,
    private service: OfflineRequestService,
    private router: Router,
    private ticketIssuanceService: TicketIssuanceService
    , private offlineNewvsService: OfflineNewVersionService
  ) {
    this.onClickEditRequest = this.onClickEditRequest.bind(this);

    //this.onClickEditSupplierVisa = this.onClickEditSupplierVisa.bind(this);
  }

  @ViewChild("confirmationModal") confirmationModal: ElementRef;

  ngOnInit() {
    try {
      this.timerSubscription = timer(0, 18000)
        .pipe(
          map(() => {
            this.loadBaseData(); // load data contains the http request
            //this.getFlightSearchHistory();
          })
        )
        .subscribe();
      this.userId = Number(localStorage.getItem("UserId"));
      this.agencyId = localStorage.getItem("AgencyId");
      this.offlineOrOnlineRequestList.agencyId = this.agencyId;
      this.offlineOrOnlineRequestList.userId = this.userId;
      this.isLoadPanelVisible = true;
      this.loadBaseData();
      this.loadrights();
      //this.loadRequestTypes();
      this.requestTypeId = Number(localStorage.getItem("requestTypeId"));
      // this.OnRequestTypeChange(this.requestTypeId);
      // Initialize filtered data for each unique requestTypeName
      //this.initializeFilteredData();
    } catch (ex) {
      console.log(ex);
    }
  }

  // ================== Adding Conditional classes-start=======================

  // @ViewChild("dataGridRequestList", { static: false })
  // dataGrid: DxDataGridComponent;
  // tabColor: string;

  // ngAfterViewInit() {
  //   // Assuming you have a specific row and column index, e.g., row = 0, column = 0
  //   const cellElement = this.dataGrid.instance.getCellElement(0, 0);

  //   // Accessing the style property of the cell element to get its color
  //   this.tabColor = cellElement.style.backgroundColor;
  // }

  // ================== Adding Conditional classes-start- end==================

  loadBaseData(): boolean {
    let check = false;
    try {
      this.service
        .GetTicketRequestOfflineListManager(this.offlineOrOnlineRequestList).subscribe((data) => {
          if (data.length == 0) {
            this.isLoadPanelVisible = false;
          }
          this.requestListForConverting = data;
           console.log(
             "requestListForConverting",
             this.requestListForConverting
           );

          for (let i = 0; i < this.requestListForConverting.length; i++) {
            let bookingdashAgencyId = `${this.requestListForConverting[i].agencyId}-${this.requestListForConverting[i].offlineBookingId}`;

            this.requestListForConverting[i].bookingAgencyId =
              bookingdashAgencyId;
            this.requestListForConverting[i].travelDate =
              this.requestListForConverting[i].travelDate.split("T")[0];
            let travelDateFormat = this.requestListForConverting[i].travelDate;

            let dateDateLong: Date = new Date(travelDateFormat);
            let datePipe: DatePipe = new DatePipe("en-UK");
            this.requestListForConverting[i].travelDate = datePipe.transform(
              dateDateLong,
              "dd/MM/yyyy"
            );
            let bookingDateFormat = this.requestListForConverting[i].creationDate;

            // Convert to Date object
            let datebookDateLong: Date = new Date(bookingDateFormat);

            // Use DatePipe for formatting (with time)
            let datebookPipe: DatePipe = new DatePipe("en-UK");
            this.requestListForConverting[i].creationDate = datebookPipe.transform(
              datebookDateLong,
              "dd/MM/yyyy HH:mm:ss" // 24-hour format with seconds
            );
          }
          //for (let i = 0; i < this.requestList.length; i++) {
          //  this.requestList[i].travelDate = this.requestList[i].date.split('T')[0];
          //  let DateFormat = this.requestList[i].travelDate;

          //  let dateDateLong: Date = new Date(DateFormat);
          //  let datePipe: DatePipe = new DatePipe('en-UK');
          //  this.requestList[i].date = (datePipe.transform(dateDateLong, 'dd/MM/yyyy'));

          //}
          if (this.requestListForConverting.length > 0) {
            // console.log(
            //   "Length of : requestListForConverting: ",
            //   this.requestListForConverting.length
            // );

            this.requestList = this.requestListForConverting;
            // console.log(
            //   "requestList is assigned data here: ",
            //   this.requestList
            // );

            this.isLoadPanelVisible = false;
            this.initializeFilteredData();
          }
          check=true;
        });
    } catch (ex) {

      console.log(ex);
    }
    return check;
  }
  contentReady = (e) => {
    $(".dx-datagrid-headers").css({
      "background-color": "#f9f9f9",
      color: "#212529",
      "font-weight": "bold",
    });
    $(".dx-datagrid-header-panel").css({ "background-color": "#f9f9f9" });
    $(".dx-toolbar-items-container").css({ "background-color": "#f9f9f9" });
    $(".dx-row.dx-data-row.dx-row-lines.dx-column-lines").css({
      border: "none",
      "background-color": "#f9f9f9",
    });
    if (!this.collapsed) {
      this.collapsed = true;
      e.component.expandRow(["EnviroCare"]);
    }
  };
  //OnRequestTypeChange(typeId) {
  //  if (typeId == 2) {

  //  }
  //  else if (typeId == 3) {
  //    this.service.getTicketRequestListManager(this.userId, this.agencyId).subscribe((data) => {
  //      this.requestList = data;
  //      for (let i = 0; i < this.requestList.length; i++) {
  //        this.requestList[i].date = this.requestList[i].date.split('T')[0];
  //        let DateFormat = this.requestList[i].date;

  //        let dateDateLong: Date = new Date(DateFormat);
  //        let datePipe: DatePipe = new DatePipe('en-UK');
  //        this.requestList[i].date = (datePipe.transform(dateDateLong, 'dd/MM/yyyy'));

  //      }
  //      if (this.requestList.length > 0) {

  //        this.isLoadPanelVisible = false;
  //      }
  //    });
  //  }
  //  else if (typeId == 4) {
  //    this.service.getVoidRequestListManager(this.userId, this.agencyId).subscribe((data) => {
  //      this.requestList = data;
  //      for (let i = 0; i < this.requestList.length; i++) {
  //        this.requestList[i].date = this.requestList[i].date.split('T')[0];
  //        let DateFormat = this.requestList[i].date;

  //        let dateDateLong: Date = new Date(DateFormat);
  //        let datePipe: DatePipe = new DatePipe('en-UK');
  //        this.requestList[i].date = (datePipe.transform(dateDateLong, 'dd/MM/yyyy'));
  //      }
  //      if (this.requestList.length > 0) {

  //        this.isLoadPanelVisible = false;
  //      }
  //    });
  //  }
  //  else if (typeId == 5) {
  //    this.service.getRefundRequestListManager(this.userId, this.agencyId).subscribe((data) => {
  //      this.requestList = data;
  //      for (let i = 0; i < this.requestList.length; i++) {
  //        this.requestList[i].date = this.requestList[i].date.split('T')[0];
  //        let DateFormat = this.requestList[i].date;

  //        let dateDateLong: Date = new Date(DateFormat);
  //        let datePipe: DatePipe = new DatePipe('en-UK');
  //        this.requestList[i].date = (datePipe.transform(dateDateLong, 'dd/MM/yyyy'));
  //      }
  //      if (this.requestList.length > 0) {

  //        this.isLoadPanelVisible = false;
  //      }
  //    });
  //  }
  //}
  onCellPrepared(e) {
    if (e.rowType === "data" && e.column.dataField === "requestTypeName") {
      /* #7df481 */

      if (e.data.requestTypeName === "Offline Ticket Request") {
        e.cellElement.style.color = "red";
        e.cellElement.style.fontWeight = "700";
      } else if (e.data.requestTypeName === "Online Import PNR Ticket Request") {               //new added
        e.cellElement.style.color = "green";
        e.cellElement.style.fontWeight = "700";
      }
      else if (e.data.requestTypeName === "Offline Void Request") {
        e.cellElement.style.color = "orange";
        e.cellElement.style.fontWeight = "700";
      } else if (e.data.requestTypeName === "Offline Refund Request") {
        e.cellElement.style.color = "green";
        e.cellElement.style.fontWeight = "700";
      } else if (e.data.requestTypeName === "Online Ticket Request") {
        e.cellElement.style.color = "red";
        e.cellElement.style.fontWeight = "700";
      } else if (e.data.requestTypeName === "Online Void Request") {
        e.cellElement.style.color = "orange";
        e.cellElement.style.fontWeight = "700";
      } else if (e.data.requestTypeName === "Online PNR Cancel Request") {
        e.cellElement.style.color = "blue";
        e.cellElement.style.fontWeight = "700";
      } else if (e.data.requestTypeName === "Online Refund Request") {
        e.cellElement.style.color = "green";
        e.cellElement.style.fontWeight = "700";
      }
      else if (e.data.requestTypeName === "Offline Booking/Group Request") {
        e.cellElement.style.color = "purple";
        e.cellElement.style.fontWeight = "700";
      }
      else if (e.data.requestTypeName === "Offline Reissue Request") {
        e.cellElement.style.color = "orange";
        e.cellElement.style.fontWeight = "700";
      }
      else {
        //e.cellElement.style.color = "green";
        e.cellElement.style.fontWeight = "700";
      }
      // Tracks the `Amount` data field
      //e.watch(function () {
      //  return e.data.requestType;
      //}, function () {
      //  e.cellElement.style.color = e.data.requestType = "Offline Ticket Request" ? "green" : "red";
      //})
    }
  }

  ngOnDestroy() {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }

  offlineObj = new OfflineNewVersionProperties();

  popupDepdetails: boolean = false;
  bookingNewChatId: number = 0;
  searchBookingNew() {

    if (this.bookingNewChatId == null || this.bookingNewChatId == undefined || this.bookingNewChatId == 0) {
      return;
    }
    this.offlineNewvsService.GetOfflineBookingByIdByCriteria(this.bookingNewChatId, Number(localStorage.getItem("UserId"))).subscribe((data) => {
      if (data != null && data.offlineId > 0) {
        this.offlineObj = data;
        this.popupDepdetails = true;
      }
    });
  }
  MoveToChat() {
    if (this.offlineObj.inProgressTag) {

      document.getElementById("inprogresstag").innerHTML =
        "In Progress Select Other One";
      document
        .getElementById("inprogresstag")
        .classList.remove("hidden-marker");
      setTimeout(() => {
        document.getElementById("inprogresstag").innerHTML = "";
        document
          .getElementById("inprogresstag")
          .classList.add("hidden-marker");
      }, 6000);
    }
    else {
      localStorage.setItem('RequestActionOffline', 'Agent');
      localStorage.setItem('RequestTypeOffline', 'Update');
      localStorage.setItem("offlineBookingId", this.offlineObj.offlineId.toString());
      localStorage.setItem("requestingAgency", this.offlineObj.requestingAgency);
      localStorage.setItem("offlineBookingCurnStatus", this.offlineObj.currentBookingStatus.toString());
      localStorage.setItem('fromOfflineRequestRoute', 'managerOfflineRequestList');
      if (this.offlineObj.offlineRequestTypeName.includes("Offline Booking")) {
        this.router.navigateByUrl('/offlineBooking');
      }
      else if (this.offlineObj.offlineRequestTypeName == "Offline Ticket Request") {
        this.router.navigateByUrl('/offlineTicket');
      }
      else if (this.offlineObj.offlineRequestTypeName == "Offline Refund Request") {
        this.router.navigateByUrl('/offlineRefund');
      }
      else if (this.offlineObj.offlineRequestTypeName == "Offline Void Request") {
        this.router.navigateByUrl('/offlineVoid');
      }
      else if (this.offlineObj.offlineRequestTypeName == "Offline Reissue Request") {
        this.router.navigateByUrl('/offlineReissue');
      }
    }
  }
  //===================Tabs for filtering the list - Start=======================

  //==========================ngPrime Tabs start===================================

  //Define filtered data for each tab
  filteredData: { [key: string]: OfflineBookingAllList[] } = {};

  //Method to initialize filtered data for each unique requestTypeName
  initializeFilteredData(): void {
    let uniqueRequestTypes: string[] = [];
    uniqueRequestTypes = this.getUniqueRequestTypes();
    this.filteredData = {};
    uniqueRequestTypes.forEach((type) => {
      this.filteredData[type] = this.filterDataByRequestType(type);
    });
  }
  //10-June-24
  selectedTabIndex: number = 0;
  getUniqueRequestTypes(): string[] {

    // Map request type names with any custom grouping or aliasing
    const mappedRequestTypes = this.requestList.map((item) => {
      // Check if the item's request type name matches the type you want to group
      if (
        (item.requestType == 3) || (item.requestType == 7 && item.groupTicketId == 0)
      ) {
        // Return a custom type name for the group
        return "Ticket Request";
      } else if (                                           //new added
        item.requestType == 15
      ) {
        return "Import PNR";
      }
      else if (
        (item.requestType == 7 && item.groupTicketId > 0)
      ) {
        // Return a custom type name for the group
        return "Group Request";
      }
      else if (
        item.requestType == 4 || item.requestType == 8
      ) {
        return "Void Request";
      } else if (
        item.requestType == 5 || item.requestType == 14
      ) {
        return "Refund Request";
      } else if (item.requestType == 12) {
        return "Cancel PNR"
      } else if (item.requestType == 2) {
        return "Booking Request"
      }
      else if (item.requestType == 16) {
        return "Reissue Request"
      } else {
        // Otherwise, return the original request type name
        return item.requestTypeName;
      }
    });

    // Convert the mapped request types array to a Set to remove duplicates
    return Array.from(new Set(mappedRequestTypes));
  }
  filterDataByRequestType(requestType: string): OfflineBookingAllList[] {
    if (requestType === "Ticket Request") {
      return this.requestList.filter(
        (item) => item.requestType == 3 || (item.requestType == 7 && item.groupTicketId == 0)
      )
    }
    else if (requestType === "Group Request") {
      return this.requestList.filter(
        (item) => (item.requestType == 7 && item.groupTicketId > 0)
      )
    }
    else if (requestType === "Import PNR") {                          //new added
      return this.requestList.filter(
        (item) => item.requestType == 15
      );
    }
    else if (requestType === "Void Request") {
      return this.requestList.filter(
        (item) => item.requestType == 4 || item.requestType == 8
      );
    } else if (requestType === "Refund Request") {
      return this.requestList.filter(
        (item) => item.requestType == 5 || item.requestType == 14
      );
    } else if (requestType === "Cancel PNR") {
      return this.requestList.filter(
        (item) => item.requestType == 12
      );

    } else if (requestType === "Booking Request") {
      return this.requestList.filter(
        (item) => item.requestType == 2
      );

    }
    else if (requestType === "Reissue Request") {                          //new added
      return this.requestList.filter(
        (item) => item.requestType == 16
      );
    }
    else {
      return this.requestList.filter(
        (item) => item.requestTypeName === requestType
      );
    }
  }
  //end





  //==========================ngPrime Tabs end  ===================================


  //===================Tabs for filtering the list - End =======================
  loadrights() {
    ////////////////////////////////////////
    this.ticketIssuanceService
      .CheckTktPnrRightsAgainstAgencyAndUserId(
        localStorage.getItem("AgencyId"),
        localStorage.getItem("UserId")
      )
      .subscribe((data2) => {
        this.tktPnrRight = data2;
        // console.log("LoadRights: tktPnrRight", this.tktPnrRight);
        //console.log("LoadRights: requestList", this.requestList);
      });
  }

  OpenModel(confirmationModal) {
    this.NewSuccess.open(confirmationModal, {
      centered: true,
      backdrop: "static",
      keyboard: false,
      size: "md",
    });
  }
  offlinetoOnline = new OfflineToOnlineProperties();
  onClickEditRequest(e) {
    try {
  
        if (e.row.data.requestTypeName == "Offline Booking/Group Request") {
        this.service
          .GetTicketRequestOfflineListManager(this.offlineOrOnlineRequestList).subscribe((data) => {
            let check = data.find(ft => ft.offlineBookingId == e.row.data.offlineBookingId);
            if (check.offlineBookingId>0) {
              if (check.status.includes("In Progress")) {
                this.loadBaseData();
                document.getElementById("inprogresstag").innerHTML =
                  "In Progress Select Other One";
                document
                  .getElementById("inprogresstag")
                  .classList.remove("hidden-marker");
                setTimeout(() => {
                  document.getElementById("inprogresstag").innerHTML = "";
                  document
                    .getElementById("inprogresstag")
                    .classList.add("hidden-marker");
                }, 6000);
             
              }
              else {
                localStorage.setItem('RequestActionOffline', 'Agent');
                localStorage.setItem('RequestTypeOffline', 'Update');
                localStorage.setItem("offlineBookingId", e.row.data.offlineBookingId);
                localStorage.setItem("requestingAgency", e.row.data.agencyId);
                localStorage.setItem("offlineBookingCurnStatus", e.row.data.currentBookingStatus);
                localStorage.setItem('fromOfflineRequestRoute', 'managerOfflineRequestList');
                this.router.navigateByUrl("/offlineBooking");
              }
            }
           
          });
        
        

      }
      else if (e.row.data.requestTypeName == "Offline Ticket Request") {
        this.service
          .GetTicketRequestOfflineListManager(this.offlineOrOnlineRequestList).subscribe((data) => {
            let check = data.find(ft => ft.offlineBookingId == e.row.data.offlineBookingId);
            if (check.offlineBookingId > 0) {
              if (check.status.includes("In Progress")) {
                this.loadBaseData();
                document.getElementById("inprogresstag").innerHTML =
                  "In Progress Select Other One";
                document
                  .getElementById("inprogresstag")
                  .classList.remove("hidden-marker");
                setTimeout(() => {
                  document.getElementById("inprogresstag").innerHTML = "";
                  document
                    .getElementById("inprogresstag")
                    .classList.add("hidden-marker");
                }, 6000);

              }
              else {
                localStorage.setItem('RequestActionOffline', 'Agent');
                localStorage.setItem('RequestTypeOffline', 'Update');
                localStorage.setItem("offlineBookingId", e.row.data.offlineBookingId);
                localStorage.setItem("requestingAgency", e.row.data.agencyId);
                localStorage.setItem('RequestTypeIdFromOffline', OfflineRequestTypeEnum.OfflineTicketRequest.toString());
                localStorage.setItem("offlineBookingCurnStatus", e.row.data.currentBookingStatus);
                localStorage.setItem('fromOfflineRequestRoute', 'managerOfflineRequestList');
                this.router.navigateByUrl("/offlineTicket");
              }
            }

          });



      }
      else if (e.row.data.requestTypeName == "Offline Void Request") {
        this.service
          .GetTicketRequestOfflineListManager(this.offlineOrOnlineRequestList).subscribe((data) => {
            let check = data.find(ft => ft.offlineBookingId == e.row.data.offlineBookingId);
            if (check.offlineBookingId > 0) {
              if (check.status.includes("In Progress")) {
                this.loadBaseData();
                document.getElementById("inprogresstag").innerHTML =
                  "In Progress Select Other One";
                document
                  .getElementById("inprogresstag")
                  .classList.remove("hidden-marker");
                setTimeout(() => {
                  document.getElementById("inprogresstag").innerHTML = "";
                  document
                    .getElementById("inprogresstag")
                    .classList.add("hidden-marker");
                }, 6000);

              }
              else {

                localStorage.setItem('RequestActionOffline', 'Agent');
                localStorage.setItem('RequestTypeOffline', 'Update');
                localStorage.setItem('RequestTypeIdFromOffline', OfflineRequestTypeEnum.OfflineVoidRequest.toString());
                localStorage.setItem("offlineBookingId", e.row.data.offlineBookingId);
                localStorage.setItem("requestingAgency", e.row.data.agencyId);
                localStorage.setItem("offlineBookingCurnStatus", e.row.data.currentBookingStatus);
                localStorage.setItem('fromOfflineRequestRoute', 'managerOfflineRequestList');
                this.router.navigateByUrl("/offlineVoid");
              }
            }

          });



      }
      else if (e.row.data.requestTypeName == "Offline Refund Request") {
        this.service
          .GetTicketRequestOfflineListManager(this.offlineOrOnlineRequestList).subscribe((data) => {
            let check = data.find(ft => ft.offlineBookingId == e.row.data.offlineBookingId);
            if (check.offlineBookingId > 0) {
              if (check.status.includes("In Progress")) {
                this.loadBaseData();
                document.getElementById("inprogresstag").innerHTML =
                  "In Progress Select Other One";
                document
                  .getElementById("inprogresstag")
                  .classList.remove("hidden-marker");
                setTimeout(() => {
                  document.getElementById("inprogresstag").innerHTML = "";
                  document
                    .getElementById("inprogresstag")
                    .classList.add("hidden-marker");
                }, 6000);

              }
              else {

                localStorage.setItem('RequestActionOffline', 'Agent');
                localStorage.setItem('RequestTypeOffline', 'Update');
                localStorage.setItem('RequestTypeIdFromOffline', OfflineRequestTypeEnum.OfflineRefundRequest.toString());
                localStorage.setItem("offlineBookingId", e.row.data.offlineBookingId);
                localStorage.setItem("requestingAgency", e.row.data.agencyId);
                localStorage.setItem("offlineBookingCurnStatus", e.row.data.currentBookingStatus);
                localStorage.setItem('fromOfflineRequestRoute', 'managerOfflineRequestList');
                this.router.navigateByUrl("/offlineRefund");
              }
            }

          });



      }
      else if (e.row.data.requestTypeName == "Offline Reissue Request") {
        this.service
          .GetTicketRequestOfflineListManager(this.offlineOrOnlineRequestList).subscribe((data) => {
            let check = data.find(ft => ft.offlineBookingId == e.row.data.offlineBookingId);
            if (check.offlineBookingId > 0) {
              if (check.status.includes("In Progress")) {
                this.loadBaseData();
                document.getElementById("inprogresstag").innerHTML =
                  "In Progress Select Other One";
                document
                  .getElementById("inprogresstag")
                  .classList.remove("hidden-marker");
                setTimeout(() => {
                  document.getElementById("inprogresstag").innerHTML = "";
                  document
                    .getElementById("inprogresstag")
                    .classList.add("hidden-marker");
                }, 6000);

              }
              else {

                localStorage.setItem('RequestActionOffline', 'Agent');
                localStorage.setItem('RequestTypeOffline', 'Update');
                localStorage.setItem('RequestTypeIdFromOffline', OfflineRequestTypeEnum.OfflineReissueRequest.toString());
                localStorage.setItem("offlineBookingId", e.row.data.offlineBookingId);
                localStorage.setItem("requestingAgency", e.row.data.agencyId);
                localStorage.setItem("offlineBookingCurnStatus", e.row.data.currentBookingStatus);
                localStorage.setItem('fromOfflineRequestRoute', 'managerOfflineRequestList');
                this.router.navigateByUrl("/offlineReissue");
              }
            }

          });



      }

      //20-jan-24
      //end
    } catch (ex) {
      console.log(ex);
    }
  }
  requestData: any;
  IssueTicketRequestOnline() {
    localStorage.setItem("bookingID", this.requestData.onlineBookingId);
    this.offlinetoOnline.RequestTypeIdOffline =
      this.requestData.requestTypeName;
    this.offlinetoOnline.AgencyTicketReqFromOffline = this.requestData.agencyId;
    this.offlinetoOnline.TicketIssueReqFromOffline = true;
    localStorage.setItem("fromroutePageNoright", "OfflinePage");
    this.offlinetoOnline.OfflineId = Number(this.requestData.offlineBookingId);
    localStorage.setItem(
      "OfflineToOnline",
      JSON.stringify(this.offlinetoOnline)
    );
    this.NewSuccess.dismissAll();
    if (this.requestData.requestTypeName == 'Online Import PNR Ticket Request') {
      localStorage.setItem("importPNRID", this.requestData.onlineBookingId);
      this.router.navigateByUrl('/importPNR');
    }
    else {
      this.router.navigateByUrl("/ticket-issuance");
    }

  }
  IssueTicketRequestOffline() {
    localStorage.setItem("bookingID", this.requestData.onlineBookingId);
    this.NewSuccess.dismissAll();
    this.router.navigate(["offlineTicketIssue"]);
  }
  viewprofileRefund: boolean = false;
  viewProfileRefundOpen() {
    this.viewprofileRefund = true;
  }
  //AddNewRequest() {

  //  localStorage.removeItem('offlineBookingId');
  //  localStorage.setItem('fromOfflineRequestRoute', 'managerOfflineRequestList');

  //  this.router.navigateByUrl('/offlineRequestAddEdit');
  //}

  onTabSelected(event) {
    localStorage.setItem("activeTabIndex", event.index.toString());
  }

  //ngOnDestroy() {
    
  //}





}
